export const GEOJS_COUNTRY_URL = 'https://get.geojs.io/v1/ip/country.json';
export const CLOUDFLARE_TRACE_URL = 'https://www.cloudflare.com/cdn-cgi/trace';

export function countryCodeFromGeoJs(body: { country?: string } | null | undefined): string {
  return (body?.country ?? '').trim().toUpperCase();
}

export function countryCodeFromCloudflareTrace(body: string): string {
  const match = /^loc=([A-Za-z]{2})$/m.exec(body);
  return match?.[1]?.toUpperCase() ?? '';
}

/** UK browsers use this zone, including when the IP lookup is blocked. */
export function countryCodeFromTimeZone(timeZone: string | undefined): string {
  if (timeZone === 'Europe/London') {
    return 'GB';
  }
  return '';
}

export function readBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    return '';
  }
}
